import { Injectable } from '@angular/core';
import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    UrlTree,
    Router,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { Apollo, gql } from 'apollo-angular';
import { NotificationService } from '../shared/notification/notification.service';
import { LaunchDarklyService } from '../services/launch-darkly-service/launch-darkly-service';
import { LDContext } from 'launchdarkly-js-client-sdk';

const query = gql`
    query Query($name: String!) {
        webAccountInfo(name: $name) {
            logo
            headerTitle
            headerSubTitle
            name
            themeColor
            isActive
            customerID
            isUserAccountsEnabled
            creditCardProcessingMethod
            stripeAccountID
        }
    }
`;

@Injectable({
    providedIn: 'root',
})
export class CanActivateAppGuard implements CanActivate {
    constructor(
        private router: Router,
        private apollo: Apollo,
        private notificationService: NotificationService,
        private launchDarklyService: LaunchDarklyService
    ) {}
    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        return this.apollo.query({ query }).pipe(
            switchMap(async (result: any) => {
                const existingLDUser: LDContext = this.launchDarklyService.getContext();

                if (result.data.webAccountInfo) {
                    if (result.data.webAccountInfo.customerID > 0) {
                        if (
                            !existingLDUser ||
                            existingLDUser.key !==
                                result.data.webAccountInfo.customerID
                        ) {
                            await this.launchDarklyService.setContext({
                                key: result.data.webAccountInfo.customerID,
                                kind: 'user',
                            });
                        }

                        localStorage.setItem(
                            'Customer_ID',
                            result.data.webAccountInfo.customerID
                        );
                    }

                    localStorage.setItem(
                        'User_Account_Enabled',
                        result.data.webAccountInfo.isUserAccountsEnabled
                    );

                    localStorage.setItem(
                        'Credit_Card_Processing_Method',
                        result.data.webAccountInfo.creditCardProcessingMethod
                    );

                    localStorage.setItem(
                        'Stripe_Account_ID',
                        result.data.webAccountInfo.stripeAccountID
                    );
                }

                if (!result.data.webAccountInfo?.isActive) {
                    return this.router.parseUrl('/not_found');
                } else {
                    return true;
                }
            }),
            catchError((err) => {
                this.notificationService.showFailure(err);
                return of(false);
            })
        );
    }
}
